import React, { Component } from "react"

class PageTitle extends Component {
  render() {
    return (
      <div className="row page-titles">
        <div className="col-md-5 col-8 align-self-center">
          <h3 className="text-themecolor">{this.props.title}</h3>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a>Home</a>
            </li>
            <li className="breadcrumb-item active">{this.props.title}</li>
          </ol>
        </div>
        <div className="col-md-7 col-4 align-self-center">
          <a
            className="btn waves-effect waves-light btn-danger pull-right hidden-sm-down"
            href="https://wrappixel.com/templates/materialpro/"
          >
            Upgrade to Pro
          </a>
        </div>
      </div>
    )
  }
}

export default PageTitle



// WEBPACK FOOTER //
// ./src/Components/Layout/PageTitle.js